// src/components/RouteTracker.jsx
// Fires a GA4 page_view on every client-side route change.
// Internal Ops pages (/ops/*) are excluded — see src/lib/analytics.js.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

export default function RouteTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageView(pathname, search);
  }, [pathname, search]);

  return null;
}
